<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <leave-check-detail-header :leaveOrderData="leaveOrderData" />

        <leave-check-detail-timeline
          :leaveTimeline="leaveTimeline"
          @reload="onFetchData"
        />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import LeaveCheckDetailHeader from '@/components/leave/LeaveCheck/LeaveCheckDetailHeader'
import LeaveCheckDetailTimeline from '@/components/leave/LeaveCheck/LeaveCheckDetailTimeline'

export default {
  components: {
    LeaveCheckDetailHeader,
    LeaveCheckDetailTimeline
  },

  data() {
    return {
      leaveOrderData: {},
      leaveTimeline: []
    }
  },

  computed: {
    title() {
      return 'ขั้นตอนการอนุญาตการลา'
    }
  },

  async mounted() {
    await this.onFetchData()
  },

  methods: {
    async onFetchData() {
      const response = await this.apiGetLeaveTimeline()
      const leaveData = response?.data?.data[0] || null

      const begindate =
        this.$lang === 'Tha'
          ? this.$dateFormatByLang(leaveData.leaveBeginDate, {
              format: 'DD MMMM YYYY',
              addUnit: 'y',
              addValue: 543
            })
          : this.$dateFormat(leaveData.leaveBeginDate, {
              format: 'DD MMMM YYYY',
              locale: 'en'
            })
      const finishdate =
        this.$lang === 'Tha'
          ? this.$dateFormatByLang(leaveData.leaveFinishDate, {
              format: 'DD MMMM YYYY',
              addUnit: 'y',
              addValue: 543
            })
          : this.$dateFormat(leaveData.leaveFinishDate, {
              format: 'DD MMMM YYYY',
              locale: 'en'
            })

      this.leaveOrderData = {
        leaveOrderId: leaveData.leaveOrderID,
        leaveOrder: leaveData[`leaveTypeName${this.$lang}`]
          ? leaveData.leaveOrderID +
            ' - ' +
            leaveData[`leaveTypeName${this.$lang}`]
          : leaveData.leaveOrderID + ' - ',
        employeeName: leaveData[`employeeName${this.$lang}`]
          ? leaveData[`employeeName${this.$lang}`]
          : this.$t('noData'),
        date:
          begindate +
          ' - ' +
          finishdate +
          ' จำนวน ' +
          leaveData.leaveAmountDayText,
        document: leaveData.docFileName
      }

      if (leaveData.data) {
        this.leaveTimeline = leaveData.data.map(item => {
          let res = {}
          res.name = item[`leaveStatusName${this.$lang}`] || this.$t('noData')
          res.approved = item.employeeApproveName || null
          res.color = item.color || 'primary'

          if (item.processDate) {
            res.date = this.$dateFormatByLang(item.processDate, {
              format: 'DD MMMM YYYY HH:mm:ss'
            })
          } else {
            res.date = null
          }

          if (item.approveStatusID === 'W') {
            res.reason = null
          } else {
            res.reason = item.description
          }

          if (item.backEmployeeName) {
            res.reject = {
              date: this.$dateFormatByLang(item.backDate, {
                format: 'DD MMMM YYYY HH:mm:ss'
              }),
              name: item.backEmployeeName || '',
              description: item.backDescription || ''
            }
          } else {
            res.reject = null
          }

          return { ...item, ...res }
        })
        this.leaveTimeline.reverse()
      }
    },

    async apiGetLeaveTimeline() {
      try {
        const payload = {
          leaveOrderId: this.$route.params.leaveOrderId,
          employeeId: this.$guid
        }
        const res = await this.$store.dispatch(
          'leave/getLeaveTimeline',
          payload
        )
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
